import {
    Activity,
    User,
    Clock3,
    ShieldCheck,
} from "lucide-react";

import "./ActivityTab.css";

function ActivityTab({ order }) {

    const activities = order.activities || [];

    return (

        <div className="activity-tab">

            <div className="activity-header">

                <h2>Activity Log</h2>

                <p>
                    Complete audit trail of every action performed on this order.
                </p>

            </div>

            {activities.length === 0 ? (

                <div className="activity-empty">

                    <Activity size={60} />

                    <h3>No Activity Found</h3>

                    <p>
                        No actions have been recorded for this order.
                    </p>

                </div>

            ) : (

                <div className="activity-list">

                    {activities.map((activity, index) => (

                        <div
                            className="activity-card"
                            key={index}
                        >

                            <div className="activity-icon">

                                <ShieldCheck size={22} />

                            </div>

                            <div className="activity-content">

                                <h3>

                                    {activity.action}

                                </h3>

                                <p>

                                    {activity.description}

                                </p>

                                <div className="activity-footer">

                                    <span>

                                        <User size={14} />

                                        {activity.performedBy || "System"}

                                    </span>

                                    <span>

                                        <Clock3 size={14} />

                                        {activity.createdAt
                                            ? new Date(activity.createdAt).toLocaleString()
                                            : "-"}

                                    </span>

                                </div>

                            </div>

                        </div>

                    ))}

                </div>

            )}

        </div>

    );

}

export default ActivityTab;